import React from "react";
import { IonItem, IonList, IonListHeader } from "@ionic/react";
import { useIntl } from "react-intl";
import { setLanguage } from "../../auth/authSlice";
import { useDispatch } from "react-redux";

const LanguageSelector = (props) => {
  const { onHide } = props;
  const intl = useIntl();
  const dispatch = useDispatch();

  const onLanguageChoose = (lan) => {
    dispatch(setLanguage({ language: lan }));
    onHide();
  };
  return (
    <IonList>
      <IonListHeader>
        {intl.formatMessage({
          id: "app.mobile.languages",
        })}
      </IonListHeader>

      <IonItem button onClick={() => onLanguageChoose("hebrew")}>
        עברית
      </IonItem>
      <IonItem button onClick={() => onLanguageChoose("english")}>
        English
      </IonItem>
    </IonList>
  );
};

export default LanguageSelector;
